import * as XLSX from 'xlsx';

export const exportTDetailFacture = (filteredFactures) => {
    const toExcelDate = (date) => {
        if (!(date instanceof Date)) return null;
        const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        return Math.floor((date - excelEpoch) / (1000 * 60 * 60 * 24));
    };

    const formatedNumber = (num) => {
        if (num !== undefined && num !== null && !isNaN(num) && num > 0) {
            return parseFloat(num).toFixed(3);
        }
        return "";
    };

    const exportData = filteredFactures.flatMap((facture) => {
        const { consommations } = facture;
        const numberOfClients = consommations.length;
        return consommations.map((consommation, consommationIndex) => {
            const المجموع = consommation.totalConsom; 
            const العدد = consommation.quantiteConsom;
            const السعر = consommation.unitPrice;
            const الاقامة = consommation.description;
            const المبلغ_المطلوب = formatedNumber(facture.solde); 
            const معرف_الفاتورة = facture.id_facture;
            const عدد_الفواتير = facture.nbrfact;
            const النزل = facture.selectedHotel;
            const المؤسسة = facture.selectedorganisme;
            const التاريخ = toExcelDate(new Date(facture.currentDate));
            const mergeEColumn = (index) => {
                if (index === 0) {
                    return {
                        المبلغ_المطلوب,
                    };
                }
                return {
                    المبلغ_المطلوب: "",
                };
            };
            return {
                المجموع,
                العدد,
                السعر,
                الاقامة,
                ...mergeEColumn(consommationIndex),
                معرف_الفاتورة,
                عدد_الفواتير,
                النزل,
                المؤسسة,
                التاريخ,
            };
        });
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const numberColumns = ['A','C','E']; 
    numberColumns.forEach((column) => {
        for (let i = 1; i <= exportData.length; i++) {
            const cellAddress = XLSX.utils.encode_cell({ r: i, c: column.charCodeAt(0) - 65 });
            if (ws[cellAddress]) {
                ws[cellAddress].z = '#,##0.00';
            }
        }
    });
    const dateColumns = ['J'];
    dateColumns.forEach((column) => {
        for (let i = 1; i <= exportData.length; i++) {
            const cellAddress = XLSX.utils.encode_cell({ r: i, c: column.charCodeAt(0) - 65 });
            if (ws[cellAddress]) {
                ws[cellAddress].z = 'dd/mm/yyyy'; 
            }
        }
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "قائمة العملاء");
    XLSX.writeFile(wb, "قائمة العملاء.xlsx");
};
